import store from '@/store'
import getNestedValue from '@/services/functions/getNestedValue'

const propsToDelete = {
  app: ['openTrash'],
  auth: ['username']
}

function removeStoreProperties () {
  for (const key in propsToDelete) {
    const props = propsToDelete[key]
    const item = getNestedValue(key, store.state)
    if (item) {
      for (let propKey = 0; propKey < props.length; propKey++) {
        const propToDelete = props[propKey]
        if (Object.hasOwnProperty.call(item, propToDelete)) {
          if (Array.isArray(item)) {
            item.splice(propToDelete, 1)
          } else {
            delete item[propToDelete]
          }
          // console.log(`CustomLog: state.${key}[${propToDelete}] - deleted`)
        } else {
          // console.log(`CustomLog: state.${key}[${propToDelete}] - not exist`)
          props.splice(propKey, 1)
          propKey--
        }
      }
      if (!props.length) {
        // console.log(`CustomLog: state.${key} - has not more properties to delete`)
        delete propsToDelete[key]
      }
    } else {
      // console.log(`CustomLog: state.${key} - is undefined`)
      delete propsToDelete[key]
    }
  }
}

export default removeStoreProperties
